/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5 4c0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4a3.9898 3.9898 0 0 1-.2816 1.4772l4.3695 2.7806C17.8173 7.4835 18.8522 7 20 7c2.2091 0 4 1.7909 4 4 0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-.5218.0999-1.0202.2816-1.4772l-4.3695-2.7806a4.0142 4.0142 0 0 1-1.0241.785l2.6558 8.4985A4.0417 4.0417 0 0 1 14 16c2.2091 0 4 1.7909 4 4 0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-1.5263.8549-2.853 2.112-3.5273L9.4562 7.9743a4.0422 4.0422 0 0 1-1.0716-.0213L6.028 14.5515C7.2082 15.247 8 16.531 8 18c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4a4.04 4.04 0 0 1 .6154.047L6.972 7.4485C5.7918 6.753 5 5.469 5 4Zm4-2.5882C7.5706 1.4118 6.4118 2.5706 6.4118 4S7.5706 6.5882 9 6.5882 11.5882 5.4294 11.5882 4 10.4294 1.4118 9 1.4118ZM4 15.5c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5Zm16-7c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5ZM11.5 20c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5-1.1193 2.5-2.5 2.5-2.5-1.1193-2.5-2.5Z"
    clipRule="evenodd"
  />,
  'Node'
);
